import PropTypes from 'prop-types';

import OrganizationProfileForm from '../account-info/OrganizationProfileForm';

const OrganizationProfileStep = ({ onNext, onPrev }) => {
  return (
    <div className="m-auto max-w-2xl pb-[60px] 2xl:max-w-5xl">
      <OrganizationProfileForm onboarding onNext={onNext} onPrev={onPrev} />
    </div>
  );
};

OrganizationProfileStep.propTypes = {
  onNext: PropTypes.func.isRequired,
  onPrev: PropTypes.func.isRequired,
};

export default OrganizationProfileStep;
